<template>
  <div class="card mb-25 border-0 rounded-0 bg-white expected-earnings-box radius-7 heigth-other-cards-dashboard">
    <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing radius-7 total-success-card spacing-cards-dashboard">
      <div>
        <span class="d-block mb-6 fs-13 text-uppercase fw-medium text-dark-emphasis font-cards-dashboard">Uploads com sucesso</span>
        <h4 class="fw-black mb-12 lh-1 font-size-32">{{ getDashboardDayCards.total_success }}</h4>
      </div>

      <div>
        <div class="mt-15 mt-md-25 mb-8 mb-md-12 d-flex justify-content-between align-items-center">
          <span class="fw-medium text-secondary">
            <span class="fw-bold text-black">Porcentagem de sucesso</span>
          </span>
          <span class="text-primary fw-semibold">{{ getDashboardDayCards.total_percentage_success }}%</span>
        </div>
  
        <div class="progress" role="progressbar" aria-valuenow="68" aria-valuemin="0" aria-valuemax="100">
          <div class="progress-bar" :style="{ width: getDashboardDayCards.total_percentage_success + '%' }"></div>
        </div>
      </div>

    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { mapGetters } from 'vuex';

export default defineComponent({
  name: "DashboardDaySuccess",
  data: function () {
    return {
      earnings: [50, 35, 45],
      earningChart: {
        dataLabels: {
          enabled: false,
        },
        colors: ["#159269", "#1D6FF2", "#20C7D9"],
        legend: {
          show: false,
          fontWeight: 500,
          fontSize: "14px",
          fontFamily: "Red Hat Display, sans-serif",
          labels: {
            colors: "#607089",
          },
          markers: {
            offsetX: -2,
            offsetY: 1,
          },
        },
        stroke: {
          width: 0,
        },
        tooltip: {
          enabled: false,
          style: {
            fontSize: "14px",
            fontFamily: "Red Hat Display, sans-serif",
          },
        },
      },
    };
  },
  computed:{
    ...mapGetters([
      'getDashboardDayCards'
    ])
  },
});
</script>
